import { Radio } from "@mantine/core";
import { TStaffSurveyStatus } from "../../../types/TStaffSurveyStatus";
import { RadioSurvey } from "../../../components";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
  staff_survey: TStaffSurveyStatus;
};

const Component = ({ form, staff_survey }: Props) => {
  const { t } = useTranslation();
  return (
    <RadioSurvey
      label={t("gender.select")}
      {...form.getInputProps("IP_001_genero")}
      orientation="vertical"
    >
      <Radio label={`${t("gender.male")}.`} value="Masculino." />
      <Radio label={`${t("gender.female")}.`} value="Femenino." />
      {staff_survey.flag_001 && (
        <Radio label={`${t("gender.nonBinary")}.`} value="No binario." />
      )}
    </RadioSurvey>
  );
};

export default Component;
